import { useEffect, useRef, useState } from 'react';
import { getActorPermissions, validateApiResponse } from '@aimsos/people-access/permissions';

/**
 * The signed-in actor (`{ user_type, permissions }`) the Settings menu is filtered with.
 * `null` while loading and if the request fails: nothing gated is shown in either case.
 * contract TBD (ARP/backend): the source is the People & Access mock service for now.
 *
 * @param {{ onError?: (error: Error) => void }} [options] Called once if the request fails.
 */
export const useSettingsActor = ({ onError } = {}) => {
  const [actor, setActor] = useState(null);
  const onErrorRef = useRef(onError);

  useEffect(() => {
    onErrorRef.current = onError;
  });

  useEffect(() => {
    let mounted = true;

    getActorPermissions()
      .then((res) => validateApiResponse(res, 'Could not load permissions'))
      .then(({ body }) => {
        if (mounted) setActor(body?.actor ?? null);
      })
      .catch((error) => {
        if (!mounted) return;
        setActor(null);
        onErrorRef.current?.(error);
      });

    return () => {
      mounted = false;
    };
  }, []);

  return actor;
};
